import {
	OAUTH_LOGIN_USER,
	OAUTH_LOGIN_USER_SUCCESS,
	OAUTH_LOGIN_USER_ERROR,
	OAUTH_SELECT_BRANCH,
	OAUTH_SELECT_BRANCH_SUCCESS,
	OAUTH_SELECT_BRANCH_ERROR,
} from '../actions-registry';

export const oauthLoginUser = (user, history, clientId, state) => ({
	type: OAUTH_LOGIN_USER,
	payload: { user, history, clientId, state },
});
export const oauthLoginUserSuccess = (user) => ({
	type: OAUTH_LOGIN_USER_SUCCESS,
	payload: user,
});
export const oauthLoginUserError = (message) => ({
	type: OAUTH_LOGIN_USER_ERROR,
	payload: { message },
});
export const oauthSelectBranch = (value, history, state) => ({
	type: OAUTH_SELECT_BRANCH,
	payload: { value, history, state },
});
export const oauthSelectBranchSuccess = (value) => ({
	type: OAUTH_SELECT_BRANCH_SUCCESS,
	payload: { value },
});
export const oauthSelectBranchError = (message) => ({
	type: OAUTH_SELECT_BRANCH_ERROR,
	payload: { message },
});
